import api from './api';

// Talks to /api/assets/* — the asset register.
//
// Master data, so unlike the budget services this needs NO budget version. Site
// comes from the x-site-code header (set by the api interceptor); with no site
// selected the register returns every site. The version header is still sent and
// is used server-side only to populate the work-centre picker.
export const assetService = {
  // { assets, areas, classes, costCenters, workCenters }
  getAssets: async () => {
    const res = await api.get('/assets');
    return res.data;
  },

  // payload: { assets: [ ...upserted... ] }
  saveAssets: async (payload) => {
    const res = await api.put('/assets', payload);
    return res.data;
  },

  // Components cascade with their parent.
  deleteAsset: async (assetCode) => {
    const res = await api.delete('/assets', { data: { asset_code: assetCode } });
    return res.data;
  },

  // payload: { areas: [{ site_code?, code, description, cost_center_code? }] }
  saveAreas: async (payload) => {
    const res = await api.put('/assets/areas', payload);
    return res.data;
  },

  deleteArea: async (areaCode, siteCode) => {
    const res = await api.delete('/assets/areas', { data: { area_code: areaCode, site_code: siteCode } });
    return res.data;
  },

  // payload: { classes: [{ code, description, meter_uom? }] }
  saveClasses: async (payload) => {
    const res = await api.put('/assets/classes', payload);
    return res.data;
  },
};

export default assetService;
